import React from "react";
import RoomHeader from "../RoomHeader";
import Loginmask from "./../../../misc/login/Loginmask";
import EquipmentHardwareItem from "./EquipmentHardwareItem";
import {
  FaEyeSlash,
  FaLaptop,
  FaMicrophoneSlash,
  FaVideoSlash,
} from "react-icons/fa";
import { FaVideo } from "react-icons/fa";
import { FaMicrophone } from "react-icons/fa";
import { FaSlideshare } from "react-icons/fa";
import "./EquipmentHardwareStyle.css";

const EquipmentHardware = ({ selectedRoom, loggedIn, loginSetter }) => {
  const beamerPresent = "Beamer vorhanden";
  const beamerNotPresent = "Kein Beamer vorhanden";
  const micPresent = "Mikrofon vorhanden";
  const micNotPresent = "Kein Mikrofon vorhanden";
  const videoRecPresent = "Videorekorder vorhanden";
  const videoRecNotPresent = "Kein Videorekorder vorhanden";
  const diaProjectPresent = "Diaprojektor vorhanden";
  const diaProjectNotPresent = "Kein Diaprojektor vorhanden";

  const loginComponent = () => {
    return (
      <div className="swiper-slide-section">
        <Loginmask loginSetter={loginSetter} rootId={1} />
      </div>
    );
  };

  const pageContent = () => {
    return (
      <div className="swiper-slide-section">
        {selectedRoom.beamer && selectedRoom.beamer === "nein" ? (
          <EquipmentHardwareItem
            icon={<FaVideoSlash />}
            label={beamerNotPresent}
          />
        ) : (
          <EquipmentHardwareItem icon={<FaVideo />} label={beamerPresent} />
        )}

        {selectedRoom.mikro && selectedRoom.mikro === "nein" ? (
          <EquipmentHardwareItem
            icon={<FaMicrophoneSlash />}
            label={micNotPresent}
          />
        ) : (
          <EquipmentHardwareItem icon={<FaMicrophone />} label={micPresent} />
        )}

        {selectedRoom.video && selectedRoom.video === "nein" ? (
          <EquipmentHardwareItem
            icon={<FaVideoSlash />}
            label={videoRecNotPresent}
          />
        ) : (
          <EquipmentHardwareItem icon={<FaVideo />} label={videoRecPresent} />
        )}

        {selectedRoom.dia && selectedRoom.dia === "nein" ? (
          <EquipmentHardwareItem
            icon={<FaEyeSlash />}
            label={diaProjectNotPresent}
          />
        ) : (
          <EquipmentHardwareItem
            icon={<FaSlideshare />}
            label={diaProjectPresent}
          />
        )}
      </div>
    );
  };

  return (
    <div className="equipmentHardware-container">
      <RoomHeader
        title="Equipment &amp; Hardware"
        subtitle={selectedRoom.hoersaal}
        icon={<FaLaptop className="section-indocator-icon" />}
      />

      {loggedIn ? pageContent() : loginComponent()}
    </div>
  );
};

export default EquipmentHardware;
